import { Injectable } from '@angular/core';
// import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import { environment } from '../../environments/environment';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS, HttpErrorResponse } from '@angular/common/http';
import { JwtHelper } from 'angular2-jwt';
import { NotificationsService } from 'angular4-notifications';
import { Router } from '@angular/router';

@Injectable()
export class AuthenticationService {
    
    token: string;
    roles: any;
    userid: string;
    token_refresh: string;
    jwtHelper: JwtHelper = new JwtHelper();
    // email: string;

    constructor(private http: HttpClient, private notificationService: NotificationsService, private router:Router) {
        // set token if saved in local storage
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.token = currentUser && currentUser.token;
        this.token_refresh = currentUser && currentUser.refresh_token;

    }

    login(username: string, password: string): Observable<boolean>{
        // TODO : use POST instead of PUT : renvoi erreur deprecated
        return this.http.put(environment.symfonyEndpointNotSecured + environment.apiLogin, '{"username":"' + username + '","password":"' + password + '"}')
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                if (response['token'] != null) {
                    this.token = response['token'];
                    this.roles = response['roles'];
                    this.userid = response['userId'];
                    this.token_refresh = response['refreshToken'];
                    // this.email = response['email'];

                    // store username and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify({ username: username, userid: this.userid, roles: this.roles, token: this.token, refresh_token: this.token_refresh}));

                    // return true to indicate successful login
                    return true;
                } else {
                    return false;
                }
            }).catch((err: HttpErrorResponse) => {
                console.error(err);
                //https://stackoverflow.com/questions/46019771/catching-errors-in-angular-httpclient
                return Observable.of(false);
            });

    }

    register(username: string, email: string, passwordFirst: string, passwordSecond: string): Observable<boolean>{
        // TODO : use POST instead of PUT : renvoi erreur deprecated
        
        let body = '{' +
            '"username":"' + username + '",' +
            '"email":"' + email + '",' +
            '"plainPassword": ' + 
                '{"first":"' + passwordFirst + '",' +
                '"second":"' + passwordSecond + '"}' +
        '}';

        return this.http.put(environment.symfonyEndpointNotSecured + environment.apiRegister, body)
            .map((response: Response) => {
                // no error catch so response is successfull
                return true;
            }).catch((err: HttpErrorResponse) => {
                //https://stackoverflow.com/questions/46019771/catching-errors-in-angular-httpclient
                return Observable.of(err);
            });

    }

    resetPwdRequest(email: string): Observable<boolean>{
        let body = '{' +
            '"email": "' + email + '"}';

        return this.http.put(environment.symfonyEndpointNotSecured + environment.apiResetPwdRequest, body)
            .map((response: Response) => {
                // no error catch so response is successfull
                return true;
            }).catch((err: HttpErrorResponse) => {
                return Observable.of(err);
            });
    }

    logout(): void {
        // clear token remove user from local storage to log user out
        this.token = null;
        localStorage.removeItem('currentUser');
    }

    registerCpy(credentials): Observable<boolean>{
        // TODO : use POST instead of PUT : renvoi erreur deprecated

        let body = '{' +
            '"name":"' + credentials['name'] + '",' +
            '"email":"' + credentials['email'] + '",' +
            '"plainPassword": ' + 
                '{"first":"' + credentials['passwordFirst'] + '",' +
                '"second":"' + credentials['passwordSecond'] + '"},' +
            '"siret": "' + credentials['siret'] + '",' +
            '"street": "' + credentials['street'] + '",' +
            '"streetSecond": "' + credentials['streetSecond'] + '",' +
            '"city": "' + credentials['city'] + '",' +
            '"postCode": "' + credentials['postCode'] + '",' +
            '"country": "' + credentials['country'] + '",' +
            '"companySize": "' + credentials['companySize'] + '",' +
            '"managers": [{"name": "' + credentials['manager_name'] + '",' +
                '"firstname": "' + credentials['manager_firstname'] + '",' +
                '"email": "' + credentials['manager_email'] + '",' +
                '"function": "' + credentials['manager_function'] + '",' +
                '"phone": "' + credentials['manager_phone'] + '",' +
                '"mainContact": "' + credentials['manager_main_contact'] + '"' +
            '}]' + 
        '}';

        return this.http.put(environment.symfonyEndpointNotSecured + environment.apiRegisterCpy, body)
            .map((response: Response) => {
                // no error catch so response is successfull
                return true;
            }).catch((err: HttpErrorResponse) => {
                //https://stackoverflow.com/questions/46019771/catching-errors-in-angular-httpclient
                return Observable.of(err);
            });

    }

    public getToken() {

         if(this.jwtHelper.isTokenExpired(this.token)){
            
            this.notificationService.error('Oups', 'Vous devez vous reconnecter');
            this.logout();
            this.router.navigate(["/"]);

            // TODO marche depuis postman mais pas depuis angular
            // call API to refresh token
            // this.http.put(environment.apiRefreshToken, '{"refresh_token" : "' + this.token_refresh + '"}')
            // .subscribe(
            //     res => {
            //         console.log('$$$$ refresh is OK');
            //         this.token = res['token'];
            //         console.log(res);
            //         return this.token;
            //     },
            //     err => {
            //         console.log('$$$$ refresh failed');
            //           console.error(JSON.parse(err['error']).message);
            //     });

        }else{
            return this.token;
        }
     }
}



// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/services/authentication.service.ts